import React, {useEffect, useState} from "react";
import "./Courses.scss";
import CourseCard from "../../../../components/CourseCard";
import {CourseService} from "../../../services/course-api.service";
import {Empty, Spin} from "antd";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const response = await CourseService.getAllCourses();
      console.log("API Response:", response);
      if (response.data.data.data.result) {
        // Map the API response to match our CourseCard props structure
        const formattedCourses = response.data.data.data.result.map(course => ({
          id: course._id,
          image: course.thumbnail,
          title: course.title,
          author: course.userDetails?.fullName || "Unknown Author",
          experience: course.userDetails?.additionalFields?.businessIndustry || "Educator",
          videos: course.videoCount || course.videos?.length || 0,
          description: course.description,
          // Store the original data for reference if needed later
          originalData: course,
          videosWatched:course.videosWatched
        }));
        setCourses(formattedCourses);
      }
    } catch (err) {
      console.error("Error fetching courses:", err);
      setError("Failed to load courses. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="courses-page">
      <div className="courses-header">
        <h2>Courses</h2>
      </div>
      
      {loading ? (
        <div className="loading-container">
          <Spin size="large" />
        </div>
      ) : error ? (
        <div className="error-container">
          <p>{error}</p>
        </div>
      ) : courses.length > 0 ? (
        <div className="courses-grid">
          {courses.map((course) => (
            <CourseCard key={course.id} {...course} />
          ))}
        </div>
      ) : (
        <div className="empty-container">
          <Empty description="No courses found" />
        </div>
      )}
    </div>
  );
};

export default Courses;